<template>
  <main>
    <div class="header-section">
      <AdminHeader />
    </div>
    <slot />
  </main>
</template>

<script>
import AdminHeader from '~/components/header/AdminHeader.vue'
export default {
  name: 'AdminLayout',
  components: {AdminHeader},
  setup() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.header-section {
  height: 64px;
}
</style>
